import { Component, TemplateRef, ViewChild } from '@angular/core';

import { TableAction } from '../../../../../shared/ui/custom-table/model/table-action.model';
import { TableColumn } from '../../../../../shared/ui/custom-table/model/table-column.model';
import { LoadingDialogService } from '../../../../../shared/ui/loading/loading-dialog.service';
import { PaymentCardTypes } from '../../../../../modules/finanzas/paymentcard/paymentcard.model';
import { PaymentCardDialogMovimientoTarjetaCreditoComponent } from '../../../../../modules/finanzas/paymentcard/tarjeta-credito/paymentcard-dialog-movimiento-tarjeta-credito.component';
import { AccountingAccountsService } from '../../../../../modules/accounting/accounting-accounts/accounting-accounts.service';
import { AccountingAccountsModel } from '../../../../../modules/accounting/accounting-accounts/accounting-accounts.model';
import { AccountingAccountsDialogLedgerComponent } from '../../../../../modules/accounting/accounting-accounts/accounting-accounts-dialog-ledger.component';
import { PaymentCardListBase } from '../shared/payment-card-list.base';
import { CREDIT_CARD_MOVEMENT, PaymentCardRow } from '../../payment-card.utils';

@Component({
  standalone: false,
  selector: 'app-credit-card-list-v2',
  templateUrl: './credit-card-list.components.html',
  styleUrls: ['./credit-card-list.components.css']
})
export class CreditCardListV2Component extends PaymentCardListBase {

  @ViewChild('expandDetail') expandDetailTpl!: TemplateRef<any>;

  readonly cardType = PaymentCardTypes.Tarjeta_Credito;
  readonly icon = 'credit_card';
  readonly title = 'Tarjetas de crédito';
  readonly subTitle = 'Consulta, edita o gestiona tus tarjetas de crédito, disposiciones y liquidaciones';
  protected readonly entityLabel = 'tarjetas de crédito';
  protected override readonly expandable = true;

  constructor(
    private accountingAccountsService: AccountingAccountsService,
    private loading: LoadingDialogService,
  ) {
    super();
  }

  protected override expandTemplate(): TemplateRef<any> {
    return this.expandDetailTpl;
  }

  protected rowActions(): TableAction[] {
    return [
      { label: 'Nueva disposición', icon: 'payment', callback: (row: PaymentCardRow) => this.movement(row, CREDIT_CARD_MOVEMENT.Disposicion) },
      { label: 'Nueva liquidación', icon: 'account_balance_wallet', callback: (row: PaymentCardRow) => this.movement(row, CREDIT_CARD_MOVEMENT.Liquidacion) },
      { label: 'Mayor contable', icon: 'library_books', visible: (row: PaymentCardRow) => !!row.accountNumber, callback: (row: PaymentCardRow) => this.ledger(row) },
      { label: 'Editar', icon: 'edit', callback: (row: PaymentCardRow) => this.edit(row) },
      { label: 'Eliminar', icon: 'delete', callback: (row: PaymentCardRow) => this.delete(row) },
    ];
  }

  protected extraColumns(): TableColumn[] {
    return [
      { key: 'accountNumber', label: 'Cuenta contable', sortable: true, sortKey: 'accountNumber' },
    ];
  }

  protected deleteMessage(): string {
    return 'Se eliminarán también sus disposiciones y liquidaciones con sus asientos contables, y la cuenta contable si no tiene otros movimientos. Esta acción no se puede deshacer.';
  }

  movement(row: PaymentCardRow, tipoMovimientoTarjetaCreditoId: number): void {
    if (!this.tier.requireAdvancedTier()) return;
    PaymentCardDialogMovimientoTarjetaCreditoComponent.open(this.dialog, { paymentCard: row, tipoMovimientoTarjetaCreditoId })
      .subscribe(changed => { if (changed) this.load(); });
  }

  reload(): void {
    this.load();
  }

  ledger(row: PaymentCardRow): void {
    if (!this.tier.requireAdvancedTier()) return;
    const accountNumber = row.accountNumber;
    if (!accountNumber) {
      this.notify.warning('Esta tarjeta no dispone de cuenta contable asociada');
      return;
    }
    this.loading.run('Buscando cuenta contable…', this.accountingAccountsService.list(0, 1, accountNumber))
      .then((response: any) => {
        const list = ((response && response.data) || []) as AccountingAccountsModel[];
        const account = list.find(a => a.number === accountNumber) || (list.length === 1 ? list[0] : null);
        if (!account) {
          this.notify.warning('No se encontró la cuenta contable de la tarjeta');
          return;
        }
        this.dialog.open(AccountingAccountsDialogLedgerComponent, {
          width: '700px',
          maxWidth: '96vw',
          maxHeight: '90vh',
          autoFocus: false,
          data: {
            id: account.id,
            name: account.name,
            number: account.number,
          }
        });
      })
      .catch(() => this.notify.error('No se pudo cargar la cuenta contable'));
  }
}
